import React from 'react'

export default function HyperlinkText({ text, sub }) {
  const tokens = text?.split(/(?:\r\n|\r|\n|\s)+/);
  // const regex = /(?<link>(https?:\/\/[^\s]+))|(?<email>\S+@\S+\.\S+)/g;
  const regex = /(?<link>https?:\/\/[^\s]+)|(?<email>\S+@\S+\.\S+)/;

  return (
    <div
      style={{ whiteSpace: "pre-line" }}
      className={sub ? "Sub-Heading-CardParent" : undefined}
    >
      {tokens?.map((token, index) => {
        const match = token.match(regex);
        if (match) {
          const { link="", email="" } = match?.groups;
          if (link) {
            return (
              <a
                key={index}
                rel="noopener noreferrer"
                target="_blank"
                href={link}
              >
                {link}
              </a>
            );
          } else if (email) {
            return (
              <a key={index} href={`mailto:${email}`}>
                {email}
              </a>
            );
          }
        }
        return token+" ";
      })}
    </div>
  );
}